import { defineMessages } from "react-intl";

export const showApprovalConfirmationMessages = defineMessages({
  title: {
    id: "dialogs.show-approval-confirmation.title",
    defaultMessage: "Change Approval Required",
  },
  text: {
    id: "dialogs.show-approval-confirmation.text",
    defaultMessage:
      "This change requires approval. An approval request will be forwarded to the designated approvers. You can view the status of the approval request under My Organization > My Request Status.",
  },
  userCommentLabel: {
    id: "dialogs.show-approval-confirmation.user-comment-label",
    defaultMessage: "UserComment",
  },
});
